import '@/helpers/cookie-consent';
import { lazyLoadVideo } from '@/helpers/lazy-video';

const getSectionNames = async () => {
    // Include subdirectories by setting the second parameter to true
    const context = require.context('@/sections', true, /\.js$/);

    return context.keys().map(filePath => {
        // Extract the section name with folder structure
        return filePath.replace('./', '').replace('.js', '');
    });
};

const importSections = async () => {
    const sectionNames = await getSectionNames();

    // Check if any sections are present in the DOM
    const hasSections = sectionNames.some(name =>
        document.querySelector(`section[data-js-import="${name}"]`)
    );

    if (!hasSections) {
        console.log('No sections to import.');
        return;
    }

    // Proceed with importing sections if any are present
    sectionNames
        .filter(name => document.querySelector(`section[data-js-import="${name}"]`))
        .forEach(name => {
            import(
                `@/sections/${name}`
                );
        });
};

// Call the function to import sections
importSections();


// ping ai
const circles = document.querySelectorAll('.js-ping-ai');
document.addEventListener('mousemove', (e) => {
    const mouseX = e.clientX;
    const mouseY = e.clientY;

    circles.forEach(circle => {
        const rect = circle.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const angle = Math.atan2(mouseY - centerY, mouseX - centerX);
        let maxOffset;
        if (circle.classList.contains('large')) {
            maxOffset = 40;
        } else {
            maxOffset = 10;
        }
        const offsetX = maxOffset * Math.cos(angle);
        const offsetY = maxOffset * Math.sin(angle);
        const leftEye = circle.querySelector('.js-eye-left');
        const rightEye = circle.querySelector('.js-eye-right');
        leftEye.style.transform = `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px))`;
        rightEye.style.transform = `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px))`;
    });
});



// Konami code
// (function() {
//     const konamiCode = [
//         "ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown",
//         "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight",
//         "b", "a", "Enter"
//     ];
//     let currentIndex = 0;
//
//     document.addEventListener("keydown", function(e) {
//         if (e.key === konamiCode[currentIndex]) {
//             currentIndex++;
//             if (currentIndex === konamiCode.length) {
//                 document.body.classList.add("special");
//                 currentIndex = 0; // reset after successful code entry
//             }
//         } else {
//             currentIndex = 0; // reset on wrong key
//         }
//     });
// })();


document.addEventListener("DOMContentLoaded", function() {
    // lazy load videos
    document.querySelectorAll('.js-lazy-video').forEach((video) => {
        setTimeout(() => {
            lazyLoadVideo(video);
        }, 500);
    });

    console.log("Don't shoot ping!")


    // Select all elements that should fade in.
    const fadeElements = document.querySelectorAll('.fade-in-section');

    // Create an Intersection Observer instance.
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        // You can adjust the threshold or rootMargin if needed.
        threshold: 0.5
    });

    // Observe each fade-in element.
    fadeElements.forEach(el => observer.observe(el));



    // Promo ribbon expand logic
    const toggles = document.querySelectorAll('.promo-toggle-btn');
    console.log(toggles);
    toggles.forEach(btn => {
        btn.addEventListener('click', () => {
            const section = document.querySelector('.promo-ribbon-section');
            const isOpen  = section.classList.toggle('expanded');
            console.log(section, isOpen);
            btn.querySelector('.label').textContent = isOpen ? 'Hide Code ' : 'Get Code ';
        });
    });

});

document.querySelectorAll('.js-copy-code').forEach((copyButton) => {
   copyButton.addEventListener('click', (e) => {
       const code = e.currentTarget.dataset.code;
       navigator.clipboard.writeText(code).then(function() {
           console.log('Async: Copying to clipboard was successful!', code);
       }, function(err) {
           console.error('Async: Could not copy text: '+code, err);
       });
   })
});


const nav = document.querySelector(".js-nav-wrap");
const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
    { threshold: [1] }
);

if (observer) {
    observer.observe(nav);
}
